import { render } from "./ListUsersView.vue?vue&type=template&id=84f39084"
import script from "./ListUsersView.vue?vue&type=script&lang=js"
export * from "./ListUsersView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__